import { useGoogleLogin } from "@react-oauth/google";
import { useGoogleLoginAuth } from "../../../../hooks/authV2/useGoogleLogin.js";
import { useNavigate, useSearchParams } from "react-router-dom";
import GoogleLogo from "../../../../assets/img/homeV2/Google-Logo.png";
import toast from "react-hot-toast";
import useHandleSuccess from "../../../../utils/parent/useHandleSuccess.js";

const GoogleLoginButton = ({ onHide }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "";
  const tab = searchParams.get("tab") || "";

  const { handleSuccess } = useHandleSuccess();

  const { googleLogin, loading, error } = useGoogleLoginAuth();

  const fireLoginEvent = (userObj, roleLabel) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "login",
      method: "Google",
      user_email: userObj?.email || "",
      user_role: roleLabel || userObj?.role || "",
      user_name: userObj?.first_name || userObj?.name || "",
    });
  };

  const handleSuccessFun = async (data) => {
    fireLoginEvent(data?.user);
    await handleSuccess({ data, redirect, tab, navigate });
    onHide();
  };

  const triggerGoogleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      googleLogin(tokenResponse.access_token, handleSuccessFun);
    },
    onError: () => {
      toast.error("Google login failed. Please try again.");
    },
  });

  return (
    <>
      <button
        className="auth-social-btn"
        type="button"
        onClick={() => triggerGoogleLogin()}
        disabled={loading}
      >
        <img src={GoogleLogo} alt="Google Logo" />
        {loading ? "Signing in..." : "Continue with Google"}
      </button>
      {error && (
        <div
          className="text-danger text-center mb-2"
          style={{ fontSize: "14px" }}
        >
          {error}
        </div>
      )}
    </>
  );
};

export default GoogleLoginButton;
